module.exports = __webpack_public_path__ + "static/IMG-20200625-WA0004-5720645de4d2da44db42031d20182fc0.jpg";